import Enumeration from 'Lib/utilities/Enumeration';

const Files = new Enumeration([
    { id: 2305, name: 'Update Files' },
    { id: 2306, name: 'Upload Files' },
    { id: 2308, name: 'Share Files With Owner' },
    { id: 2309, name: 'Share Files With Tenant' },
    { id: 2310, name: 'Share Files With Vendor' }
]);

export default Files;
